module.exports = __webpack_public_path__ + "static/media/multi-sample-plp-tile-bg.6424222f.svg";